module.exports = function () {
  jQuery("select").each(function () {
    var $this = jQuery(this),
      numberOfOptions = jQuery(this).children("option").length,
      numberOfGroups = jQuery(this).children("optgroup").length;

    $this.addClass("select-hidden");
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next("div.select-styled");
    $styledSelect.text($this.children("option").eq(0).text());

    var $list = jQuery("<ul />", {
      class: "select-options",
    }).insertAfter($styledSelect);

    if (numberOfGroups > 0) {
      for (var i = 0; i < numberOfOptions; i++) {
        jQuery("<li />", {
          text: $this.children("option").eq(i).text(),
          rel: $this.children("option").eq(i).val(),
        }).appendTo($list);
      }

      for (var k = 0; k < numberOfGroups; k++) {
        jQuery("<ul>", {
          text: $this.children("optgroup").eq(k).attr("label"),
        }).appendTo($list);
        for (
          var i = 0;
          i < $this.children("optgroup").eq(k).children("option").length;
          i++
        ) {
          jQuery("<li />", {
            text: $this
              .children("optgroup")
              .eq(k)
              .children("option")
              .eq(i)
              .text(),
            rel: $this
              .children("optgroup")
              .eq(k)
              .children("option")
              .eq(i)
              .val(),
          }).appendTo($list.find("ul")[k]);
        }
      }
    } else {
      for (var i = 0; i < numberOfOptions; i++) {
        jQuery("<li />", {
          text: $this.children("option").eq(i).text(),
          rel: $this.children("option").eq(i).val(),
        }).appendTo($list);
      }
    }

    var $listItems = $list.find("li");

    $styledSelect.click(function (e) {
      e.stopPropagation();
      jQuery("div.select-styled.active")
        .not(this)
        .each(function () {
          jQuery(this).removeClass("active").next("ul.select-options").hide();
        });
      jQuery(this).toggleClass("active").next("ul.select-options").toggle();
    });

    $listItems.click(function (e) {
      e.stopPropagation();
      $styledSelect.text(jQuery(this).text()).removeClass("active");
      $this.val(jQuery(this).attr("rel"));
      $list.hide();
      //console.log($this.val());
    });

    jQuery(document).click(function () {
      $styledSelect.removeClass("active");
      $list.hide();
    });
  });
};

//SET VALUE IF IN PARAMS
jQuery.extend({
  getUrlVars: function () {
    var vars = [],
      hash;
    var hashes = window.location.href
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function (name) {
    return jQuery.getUrlVars()[name];
  },
});

// Get object of URL parameters
var allVars = jQuery.getUrlVars();
var url = window.location.href;

jQuery(document).ready(function () {
  //IF PARAM
  if (url.match(/\?./)) {
    jQuery(".home_last").remove();

    allVars.forEach((param) => {
      //IF PARAM !== NULL --> SET INPUT TEXT
      if (jQuery.getUrlVar(param) !== "")
        jQuery(
          ".filterBar_form_ctn--" + param + " " + "div.select-styled"
        ).text(
          jQuery(
            ".filterBar_form_ctn--" + param + " " + "select :selected"
          ).text()
        );
    });
  } else {
    jQuery(".annonce .home_grid > a:first-of-type").remove();
  }
});

//HOME FORM SUBMIT TO SELECTED PAGE
jQuery(".home .filterBar_form").on("submit", function (e) {
  e.preventDefault();
  removeParam(jQuery(this).find("[name=page]"));

  var page = jQuery(this).find("[name=page]").val().toLowerCase();
  var formData = jQuery(this).serialize();
  var fullUrl = window.location.href;
  var finalUrl = fullUrl + page + "/" + "?" + formData;

  window.location.href = finalUrl;
});

function removeParam(p) {
  jQuery(p).attr("disabled", true);
}
